import { useEffect, useRef, useState } from "react";
import { ArrowUp } from "lucide-react";
import { getLayerZIndex } from "../../utils/layerManager";
import styles from "./BackToTop.module.css";

const SHOW_THRESHOLD_PX = 300;

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const rafIdRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const update = () => {
      rafIdRef.current = null;
      setVisible(window.scrollY > SHOW_THRESHOLD_PX);
    };

    const onScroll = () => {
      if (rafIdRef.current != null) return;
      rafIdRef.current = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafIdRef.current != null) window.cancelAnimationFrame(rafIdRef.current);
    };
  }, []);

  const handleClick = () => {
    // Blur first so focus isn't on the button when it disappears post-scroll
    // (avoids "focus on aria-hidden element" warning).
    buttonRef.current?.blur();
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  };

  return (
    <button
      ref={buttonRef}
      type="button"
      aria-label="Back to top"
      className={`${styles.fab} ${visible ? styles.visible : ""}`}
      style={{ zIndex: getLayerZIndex("dropdown") }}
      onClick={handleClick}
    >
      <ArrowUp size={26} strokeWidth={2.5} aria-hidden="true" />
    </button>
  );
};

export default BackToTop;
